import { defineComponent as a, createBlock as t, openBlock as n, unref as r, mergeProps as c, withCtx as p, createElementVNode as m } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const f = /* @__PURE__ */ a({
  name: "IconTools",
  __name: "IconTools",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const o = l;
    return (i, e) => (n(), t(r(s), c(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "m18.176 6.835.68.226a1.25 1.25 0 0 0 1.467-.542l1.093-1.822a1.25 1.25 0 0 0-.188-1.527L20.78 2.722a1.25 1.25 0 0 0-1.527-.188l-1.821 1.093a1.25 1.25 0 0 0-.543 1.467l.227.68-3.899 3.898-.533-.533c.507-1.825.036-3.904-1.276-5.217C9.496 2.011 6.9 2.326 5.888 2.538c-.866.182-1.032 1.197-.5 1.728l2.618 2.619v1.06h-1.06l-2.62-2.619C3.797 4.796 2.782 4.961 2.6 5.828c-.212 1.01-.527 3.607 1.384 5.519 1.294 1.294 3.334 1.77 5.139 1.297l.562.562-.96.96L8.358 13.8a1.25 1.25 0 0 0-1.768 0l-3.586 3.586a2.25 2.25 0 0 0 0 3.182l.379.378a2.25 2.25 0 0 0 3.182 0l3.586-3.585a1.25 1.25 0 0 0 0-1.768l-.366-.366.96-.96 6.644 6.645a2.499 2.499 0 1 0 3.534-3.534l-6.645-6.645 3.898-3.898m1.682-2.914.171.172-.889 1.482-.573-.191-.191-.574 1.482-.889M8.913 16.477l-3.409 3.409a.75.75 0 0 1-1.06 0l-.379-.379a.75.75 0 0 1 0-1.06l3.409-3.41 1.44 1.44M9.2 5.956 7.128 3.884c.972-.05 2.244.124 3.22 1.1.977.977 1.322 2.675.78 4.091a.75.75 0 0 0 .17.799l8.564 8.564a.999.999 0 0 1-1.413 1.413l-8.587-8.587a.75.75 0 0 0-.786-.175c-1.405.51-3.069.16-4.032-.803-.975-.975-1.15-2.247-1.098-3.22l2.07 2.072A1.05 1.05 0 0 0 6.76 9.445h1.697a1.05 1.05 0 0 0 1.05-1.05V6.698A1.05 1.05 0 0 0 9.2 5.956",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
